<form [formGroup]="packagingSystemForm">

  <mat-form-field class="full-width comment-form-field" appearance="outline">
    <mat-label>{{ 'packagingUnit.fields.comment' | transloco }}</mat-label>
    <textarea class="no-resize-textarea" matInput formControlName="comment" [maxlength]="maxCommentLength"
      placeholder="{{ 'packagingUnit.fields.commentMaxLength' | transloco: {length: maxCommentLength} }}">
      </textarea>
  </mat-form-field>

  <div class="grid-container">
    <mat-card class="grid-item">
      <mat-card-title class="grid-item-title">
        {{ 'packagingUnit.fields.primaryPackagingSection' | transloco }}
      </mat-card-title>

      <mat-card-content class="inner-container inner-container-small-padding">
        <mat-form-field class="form-field-wide"
          matTooltip="{{ 'packagingUnit.fields.tooltips.brandName' | transloco }}">
          <mat-label class="label-large">{{ 'packagingUnit.fields.brandName' | transloco }}</mat-label>
          <input matInput formControlName="brandName" required type="text" autocomplete="off">
          <mat-error *ngIf="packagingSystemForm.controls.brandName.errors">
            <span *ngIf="packagingSystemForm.controls.brandName.errors.required">
              {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
            </span>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="form-field-wide"
          matTooltip="{{ 'packagingUnit.fields.tooltips.productName' | transloco }}">
          <mat-label class="label-large">{{ 'packagingUnit.fields.productName' | transloco }}
          </mat-label>
          <input matInput formControlName="productName" required type="text" autocomplete="off">
          <mat-error *ngIf="packagingSystemForm.controls.productName.errors">
            <span *ngIf="packagingSystemForm.controls.productName.errors.required">
              {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
            </span>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="form-field-wide"
          matTooltip="{{ 'packagingUnit.fields.tooltips.articleNumber' | transloco }}">
          <mat-label class="label-large">{{ 'packagingUnit.fields.articleNumber' | transloco }}
          </mat-label>
          <input matInput formControlName="articleNumber" type="text" autocomplete="off">
        </mat-form-field>

        <mat-form-field class="form-field-wide" matTooltip="{{ 'packagingUnit.fields.tooltips.gtin' | transloco }}">
          <mat-label class="label-large">{{ 'packagingUnit.fields.gtin' | transloco }}</mat-label>
          <input matInput formControlName="gtin" type="text" autocomplete="off">
          <mat-error *ngIf="packagingSystemForm.controls.gtin.errors">
            <span *ngIf="packagingSystemForm.controls.gtin.errors.gtinError">
              {{ 'dataManagement.userData.userDialog.validation.gtinError' | transloco }}
            </span>
          </mat-error>
        </mat-form-field>

        <button *ngIf="customFieldProfiles.length > 0" mat-raised-button (click)="showCustomFields()" color="primary" class="custom-fields-button" type="button">
          <mat-icon class="material-icons left">edit</mat-icon>
          {{ 'dataManagement.customFields.button' | transloco }}
        </button>
      </mat-card-content>
    </mat-card>

    <mat-card class="grid-item">
      <mat-card-title class="grid-item-title">
        {{ 'packagingUnit.fields.manufacturingSection' | transloco }}
      </mat-card-title>

      <mat-card-content class="inner-container inner-container-small-padding">
        <mat-form-field class="form-field-wide"
          [ngClass]="{'calcRelevant': relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes,packagingPartEnum.System,'distributionLocations')}"
          *ngIf="!packagingForm.distributionCountries.disabled; else disabledDistrCountries"
          matTooltip="{{ 'packagingUnit.fields.tooltips.countriesOfDistribution' | transloco }}">
          <mat-label class="label-large">
            {{ 'packagingUnit.fields.countriesOfDistribution' | transloco }}
          </mat-label>
          <mat-select class="chip-list-select" formControlName="distributionCountries" multiple>
            <mat-option *ngFor="let country of distributionCountries" [value]="country.code">
              {{ country.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="packagingForm.distributionCountries.errors">
            <span *ngIf="packagingForm.distributionCountries.errors.required">
              {{ 'dataManagement.userData.userDialog.validation.atLeastOneSelectionRequired' | transloco }}
            </span>
          </mat-error>
        </mat-form-field>
        <ng-template #disabledDistrCountries>
          <mat-form-field class="form-field-wide"
            [ngClass]="{'calcRelevant': relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes,packagingPartEnum.System,'distributionLocations')}"
            [ngStyle]="{'height': (allDistrCountryNames.length < 100 ? 100 : allDistrCountryNames.length) + 'px'}">
            <mat-label class="label-large">
              {{ 'packagingUnit.fields.countriesOfDistribution' | transloco }}
            </mat-label>
            <textarea matInput disabled class="full-height">{{allDistrCountryNames}}</textarea>
          </mat-form-field>
        </ng-template>

        <mat-form-field class="form-field-wide"
          [ngClass]="{'calcRelevant': relevantAnalysisService.isFieldRelevantForCalculations(relevantAnalysisTypes,packagingPartEnum.System,'assemblyLocation')}"
          matTooltip="{{ 'packagingUnit.fields.tooltips.assemblyCountry' | transloco }}">
          <mat-label class="label-large">
            {{ 'packagingUnit.fields.assemblyCountry' | transloco }}
          </mat-label>
          <mat-select formControlName="assemblyCountry">
            <mat-option> {{ 'common.text.noSelection' | transloco }} </mat-option>
            <mat-option *ngFor="let country of assemblyCountries" [value]="country.code">
              {{country.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="packagingSystemForm.controls.assemblyCountry.errors">
            <span *ngIf="packagingSystemForm.controls.assemblyCountry.errors.required">
              {{ 'dataManagement.userData.userDialog.validation.required' | transloco }}
            </span>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="form-field-wide top-skip">
          <mat-label class="label-large">{{ 'packagingUnit.fields.supplier' | transloco }}</mat-label>
          <input matInput formControlName="supplier" type="text" autocomplete="off">
          <mat-error *ngIf="packagingForm.supplier.errors">
            <span *ngIf="packagingForm.supplier.errors.maxlength">
              {{ 'dataManagement.userData.userDialog.validation.maxLength' | transloco: {maxLength: 120 } }}
            </span>
          </mat-error>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card class="grid-item">
      <mat-card-title class="grid-item-title">
        <div id="dimensions-header">
          {{ 'packagingUnit.fields.packagingDimensions' | transloco }}
          <button mat-icon-button matSuffix (click)="showDimensionsInfo = !showDimensionsInfo" type="button"
            cdkOverlayOrigin #dimensionsTrigger="cdkOverlayOrigin" color="primary">
            <mat-icon>info</mat-icon>
          </button>
        </div>
      </mat-card-title>
      <mat-card-content class="inner-container inner-container-small-padding">
        <mat-form-field class="form-field-wide" matTooltip="{{ 'component.fields.tooltips.length' | transloco }}">
          <mat-label class="label-large">
            {{ 'component.fields.length' | transloco }}
          </mat-label>
          <input matInput type="number" formControlName="length" autocomplete="off">
          <mat-error *ngIf="packagingSystemForm.controls.length.errors">
            <span *ngIf="packagingSystemForm.controls.length.errors.min">
              {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: {value:
              minimalValue} }}
            </span>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="form-field-wide" matTooltip="{{ 'component.fields.tooltips.width' | transloco }}">
          <mat-label class="label-large">
            {{ 'component.fields.width' | transloco }}
          </mat-label>
          <input matInput type="number" formControlName="width" autocomplete="off">
          <mat-error *ngIf="packagingSystemForm.controls.width.errors">
            <span *ngIf="packagingSystemForm.controls.width.errors.min">
              {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: {value:
              minimalValue} }}
            </span>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="form-field-wide" matTooltip="{{ 'component.fields.tooltips.height' | transloco }}">
          <mat-label class="label-large">
            {{ 'component.fields.height' | transloco }}
          </mat-label>
          <input matInput type="number" formControlName="height" autocomplete="off">
          <mat-error *ngIf="packagingSystemForm.controls.height.errors">
            <span *ngIf="packagingSystemForm.controls.height.errors.min">
              {{ 'dataManagement.userData.userDialog.validation.valueCannotBeLessThan' | transloco: {value:
              minimalValue} }}
            </span>
          </mat-error>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="dimensionsTrigger"
      cdkConnectedOverlayHasBackdrop="true" (backdropClick)="showDimensionsInfo=false"
      [cdkConnectedOverlayOpen]="showDimensionsInfo">
      <app-dimensions-info></app-dimensions-info>
    </ng-template>
  </div>
</form>
